import axios from 'axios';

const getChileanTime = async (): Promise<string> => {
	try {
		const response = await axios.get(
			'https://timeapi.io/api/time/current/zone?timeZone=America%2FSantiago',
		);
		return response.data.dateTime;
	} catch (error) {
		console.error('Error fetching Chilean time:', error);
		throw error;
	}
};

export default getChileanTime;
